export default "__VITE_ASSET__CFogvXlG__"